import request from "./api";
/**
 *    testApi   学习中心考试api
 * */
// 获取教师端考试列表
export const getTeacherExam = (courseId, classId, params, opts) =>
    request('/api-study/teacher/course/exam/list/'+courseId+'/'+classId, params, {
        ...opts
    });
// 获取学生端考试列表
export const getStudentExam = (courseId, userId, classId, params, opts) =>
    request('/api-study/student/course/exam/'+courseId+'/'+userId+'/'+classId, params, {
        ...opts
    });
// 跳转考试前的判断
export const ifIntoExam = (examId, params, opts) =>
    request('/api-study/before/verify/practise/paper/check/'+examId, params, {
        ...opts
    });
// 公布答案
export const publishAnswer = (id, params, opts) =>
    request('/api-course/course/exam/publishAnswer/'+id, params, {
        ...opts
    });


// WEBPACK FOOTER //
// ./src/api/examinationApi.js